import { Expose } from 'class-transformer'

export class MyWritingOptionType {
  @Expose({ name: 'id' })
  value: number

  @Expose({ name: 'title' })
  label: string
}
